module.exports = __webpack_public_path__ + "img/genstarmate.926848a3.svg";